import { render, staticRenderFns } from "./UserPlannedHolidays.vue?vue&type=template&id=10ca2fb5"
import script from "./UserPlannedHolidays.js?vue&type=script&lang=js&external"
export * from "./UserPlannedHolidays.js?vue&type=script&lang=js&external"
import style0 from "./UserPlannedHolidays.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports